import { axios, Response } from '../index'

export type TaskProps = {
  id?: number
  title: string
  text: string
  persons: UserInfo[]
  status: 'WAITING' | 'IN_PROGRESS' | 'FINISHED' | 'FILED'
}

export type UserInfo = {
  username: string
  userId: string
  avatarUrl: string
  activity: 'green' | 'gray' | 'red'
}

/* Not used in anywhere */

const getUserTasks = (
  companyId: string,
  personaType: string,
  personaId: string
): Response<TaskProps[]> => {
  return axios.get('tasks', {
    headers: {
      'X-CompanyID': companyId,
      'X-PersonaType': personaType,
      'X-PersonaID': personaId
    }
  })
}

export default getUserTasks
